import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'

import api from '../../utils/api'

import './auth.css'

function VerifyEmail() {
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')
    const [status, setStatus] = useState('loading')
    const [message, setMessage] = useState('Confirmando seu email...')

    useEffect(() => {
        if (!token) {
            setStatus('error')
            setMessage('Link de confirmação inválido.')
            return
        }

        api.get(`/user/verify-email/${token}`).then((response) => {
            setStatus('success')
            setMessage(response.data.message)
        }).catch((error) => {
            setStatus('error')
            setMessage(error.response?.data?.message || 'Não foi possível confirmar seu email.')
        })
    }, [token])

    return (
        <div className="auth">
            <div className="auth-box panel">
                {status !== 'loading' && (
                    status === 'success'
                        ? <FiCheckCircle size={40} className="verify-icon verify-icon-success" />
                        : <FiXCircle size={40} className="verify-icon verify-icon-error" />
                )}

                <h1 className="auth-title">Confirmação de email</h1>
                <p className="auth-subtitle">{message}</p>

                {status !== 'loading' && (
                    <p className="auth-switch">
                        <Link to="/login">Ir para o login</Link>
                    </p>
                )}
            </div>
        </div>
    )
}

export default VerifyEmail
